import React from "react";
import { Link, StaticQuery, graphql } from "gatsby";
import g from "glamorous";
import { css } from "glamor";
import Img from "gatsby-image";
import { FaFacebookSquare } from "react-icons/fa";
import { FaTwitter } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";

const mediaQueries = {
  phone: "@media only screen and (max-width: 991px)",
};

const Div = g.div({
  borderRadius: `12px 0 0 12px`,
  padding: `1.2em .75em .5em`,
  backgroundColor: `white`,
  border: `1px solid rgba(73,105,126,0.08)`,
  boxShadow: `0 1px 7px rgba(0,0,0,.05)`,
  borderRadius: `0 12px 12px 0`,
  [mediaQueries.phone]: {
    borderRadius: `12px`,
  },
});

const Nom = g.div({
  fontSize: `23px`,
  fontWeight: `600`,
  color: `#3c4d68`,
  marginTop: `1px`,
  marginBottom: `14px`,
  letterSpacing: `.015em`,
});

const P = g.p({
  fontSize: `15px`,
  lineHeight: `24px`,
});

const cssFa = css({
  color: `#3c4d68`,
  fontSize: `1.4em`,
  padding: `0 .6em`,
  marginBottom: `10px`,
});

export default () => (
  <StaticQuery
    query={graphql`
      query bioV2En {
        file(
          relativePath: {
            eq: "images/dr-cedric-kron-chirurgien-esthetique-a-paris-04.jpg"
          }
        ) {
          childImageSharp {
            resize(width: 1500, height: 1500) {
              src
            }
            fluid(maxWidth: 400) {
              ...GatsbyImageSharpFluid_tracedSVG
            }
          }
        }
      }
    `}
    render={(data) => (
      <Div>
        <div
          css={{
            width: `145px`,
            float: `left`,
            padding: `.2em`,
            borderRadius: `4px`,
            marginRight: `12px`,
          }}
        >
          {" "}
          <Link to="/en/plastic-surgeon-paris/">
            <Img
              fluid={data.file.childImageSharp.fluid}
              alt="Dr Cédric Kron, plastic surgeon in Paris"
            />
          </Link>
        </div>
        <Link to="/en/plastic-surgeon-paris/">
          <Nom>Dr Cédric Kron - Plastic surgeon in Paris</Nom>
        </Link>

        <P>
          Former resident, Gold Medal of Surgery and Head of Clinic of Paris
          Hospitals (APHP), Dr. C. Kron is qualified in Plastic, Cosmetic and
          Reconstructive Surgery. He practices as a plastic surgeon in Paris,
          with a comprehensive and tailor-made approach of aesthetic treatments.
        </P>

        <div css={{ textAlign: `right`, paddingRight: `.5em` }}>
          <a
            href="https://www.facebook.com/DrCedricKron"
            title="Page Facebook du Dr
             Cédric Kron à Paris"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaFacebookSquare {...cssFa} />
          </a>
          <a
            href="https://www.instagram.com/docteurkron/"
            title="Compte instagram du cabinet du Dr Cédric Kron"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaInstagram {...cssFa} />
          </a>
          <a
            href="https://twitter.com/Dr_Kron"
            title="Compte Twitter du Dr Cédric Kron, chirurgien esthetique"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaTwitter {...cssFa} />
          </a>
          <a
            href="https://www.youtube.com/channel/UCCbRUwoTEbXraAeMVIN9DuA"
            title="Chaine Youtube du Dr Cédric Kron"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaYoutube {...cssFa} />
          </a>
          <a
            href="https://www.linkedin.com/in/kron-c%C3%A9dric-28492917/"
            title="Profil Linkedin du Dr Cédric Kron"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaLinkedin {...cssFa} />
          </a>
        </div>
      </Div>
    )}
  />
);
